import { createAction } from 'redux-actions';
import {
  CONTACT_LIST_FETCH,
  CONTACT_LIST_SUCCESS,
  CONTACT_LIST_FAILURE,
  DELETE_CONTACT_FETCH,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-CONTACTS--->>>
export const contactListFetch = createAction(CONTACT_LIST_FETCH);
export const contactListSuccess = createAction(CONTACT_LIST_SUCCESS);
export const contactListFailure = createAction(CONTACT_LIST_FAILURE);

export const fetchContacts = () => async dispatch => {
  dispatch(contactListFetch());
  try {
    const res = await api.get('contact');
    dispatch(contactListSuccess(res.data));
  } catch (error) {
    dispatch(contactListFailure(error));
  }
};

//<<<---DELETE-CONTACT--->>>
export const deleteContactFetch = createAction(DELETE_CONTACT_FETCH);
export const deleteContactSuccess = createAction(DELETE_CONTACT_SUCCESS);
export const deleteContactFailure = createAction(DELETE_CONTACT_FAILURE);

export const deleteContact = (id, lang, callback) => async dispatch => {
  dispatch(deleteContactFetch());
  try {
    const res = await api.post(`contact/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteContactSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteContactFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ContactList/actions.js